import * as yup from 'yup';
import { useTranslation } from '~/shared/utils/translation';
import { Fields } from '../models/fields';

/**
 * Yup documentaion https://github.com/jquense/yup
 * @returns validation schema
 */

export const useValidationSchema = () => {
    const { translate } = useTranslation();

    return yup.object().shape({
        [Fields.CardNo]: yup
            .string()
            .matches(/^[0-9]{19}$/, translate('giftCardBalance.cardFormatError'))
            .required(''),
        [Fields.CVCNo]: yup
            .string()
            .matches(/^[0-9]{3}$/, translate('giftCardBalance.cvcFormatError'))
            .required(''),
    });
};
